import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import {
  DialogContent,
  Grid,
  Card,
  CardContent,
  CardHeader,
  Typography,
  Link,
} from "@mui/material";
import CloseOutlined from "@mui/icons-material/CloseOutlined";
import { JsonViewer } from "@textea/json-viewer";
import TruncateDescription from "./sharedLandingpageSections/TruncateDescription";
import ExpansionPanelStyled from "./sharedLandingpageSections/ExpansionPanelStyled";
import { useTranslator } from "../context/TranslatorContext";

export default function ConnectorAssetPolicy(props) {
  const {messages} = useTranslator();
  const validPolicy = props.validPolicy;
  const contractPolicyTitle = props.contractPolicyTitle;
  const legalCode = props.contractPolicyLegalCode;
  const description = props.contractPolicyDescription;
  // console.log(props);
  if (!validPolicy) {
    return <></>;
  }

  const Component = () => (
    <>
      <Grid item xs={12} style={{ display: "flex" }}>
        <Card
          style={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "column",
            width: "100%",
          }}
        >
          <CardHeader
            title={<Typography variant="h4">{contractPolicyTitle}</Typography>}
            subheader={
              legalCode && (
                <Typography variant="caption">
                  <Link
                    color="primary"
                    href={legalCode}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {legalCode}
                  </Link>
                </Typography>
              )
            }
          />
          <CardContent sx={{ paddingTop: "0px" }}>
            <Grid
              container
              spacing={1}
              justifyContent="flex-start"
              alignItems="center"
            >
              <Grid item xs={12}>
                <TruncateDescription
                  description={description}
                  maxLength={260}
                />
              </Grid>
              <Grid item xs={12}>
                <ExpansionPanelStyled label={<Typography variant="body1">{messages.policy_show_more_odrl}</Typography>}>
                  <JsonViewer
                    defaultInspectDepth={1000}
                    quotesOnKeys={false}
                    displayDataTypes={false}
                    displaySize={false}
                    value={validPolicy}
                  />
                  ;
                </ExpansionPanelStyled>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </>
  );

  return (
    <>
      <Dialog
        maxWidth="lg"
        slotProps={{
          backdrop: { sx: { background: "rgba(255, 255, 255, 0.25)" } },
        }}
        onClose={props.handleClose}
        open={props.open}
      >
        <DialogTitle sx={{ display: "flex", alignItems: "center" }}>
          {messages.policyDialogTitle}
          <CloseOutlined
            sx={{ ml: "auto" }}
            style={{ cursor: "pointer" }}
            onClick={props.handleClose}
          />
        </DialogTitle>
        <DialogContent dividers>
          <Component />
        </DialogContent>
      </Dialog>
    </>
  );
}
